import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'firebird-web-permission-dialog',
  templateUrl: './permission-dialog.component.html',
  styleUrls: ['./permission-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PermissionDialogComponent {}
